import { useFormContext } from 'react-hook-form';

import { VARIANTS } from 'shared';

import { ModalButton } from 'shared/components/Modal/ModalButton';

type TJournalAddNoteDialogFooter = {
  onSubmit: () => void;
};

export const JournalAddNoteDialogFooter = ({
  onSubmit,
}: TJournalAddNoteDialogFooter) => {
  const { formState } = useFormContext();

  return (
    <>
      <ModalButton variant="outline">Cancel</ModalButton>
      <ModalButton
        color={VARIANTS.PRIMARY}
        onClick={onSubmit}
        shouldClose={formState.isValid}
        dataTestid="goal-done-btn"
      >
        Save
      </ModalButton>
    </>
  );
};
